import capitializeFirstChar from './capitializeFirstChar'

export default function enumToString(str = '', splitString = '_') {
	return capitializeFirstChar(
		(str || '').toLowerCase().split(splitString).join(' '),
	)
}
